export default __webpack_public_path__ + "media/images/61-145d13de2764b4f816e0afb40dcf319b.jpg";